import styled from "styled-components";

export const StyledPointCard = styled.div`
    border-top: 1px solid ${({ theme }) => theme.disabledTypographyColor};
    padding: 8px;

    &:last-child {
        border-bottom: 1px solid ${({ theme }) => theme.disabledTypographyColor};
    }
`;

export const StyledPointList = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow-y: auto;
`;
